import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import useFetch from 'hooks/useFetch';
import { FETCH_PEOPLE } from '../actions';
export const initialState = {
    loading: false,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    error: ''
};

export const fetchPeople = createAsyncThunk(FETCH_PEOPLE, (url) => {
    return url ? useFetch(url, false) : useFetch('people');
});

const peopleSlice = createSlice({
    name: 'people',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchPeople.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(fetchPeople.fulfilled, (state, action) => {
            state.loading = false;
            state.data.count = action.payload.data.count;
            state.data.next = action.payload.data.next;
            state.data.previous = action.payload.data.previous;
            state.data.results = state.data.results.concat(action.payload.data.results);
            state.error = '';
        });

        builder.addCase(fetchPeople.rejected, (state, action) => {
            state.loading = false;
            state.data.results = [];
            state.error = action.error.message;
        });
    }
});

export default peopleSlice;
